export default __webpack_public_path__ + "static/media/biberburg.31dcc96d.jpg";